var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    (_vm.carbonPrefix + "--list-box " + _vm.carbonPrefix + "--dropdown " + _vm.carbonPrefix + "--skeleton"),
    ( _obj = {}, _obj[(_vm.carbonPrefix + "--list-box--inline")] = _vm.inline, _obj ) ],attrs:{"disabled":""}})}
var staticRenderFns = []

export { render, staticRenderFns }